// Components
import { useState } from 'react';
import { useSelector } from 'react-redux';
// Slices
import {
  fetchNumberOfReservationsToBeMoved,
  moveReservationsBetweenTimeZones,
  timeZonesSelector,
} from 'slices/timeZone.slice';
import { message } from 'utils/messageUtils';
import { Button, TEDrawerSection, TEInput } from '@timeedit/ui-components';
import { Modal } from '@timeedit/ui-components/antd';
// Types
import type { IProps } from './sections.interface';
// Styles
import './GeneralInfo.scss';

const MoveResources = ({ timeZone }: IProps) => {
  const timeZones = useSelector(timeZonesSelector);
  const otherTimezones = timeZones.filter((zone) => zone.id !== timeZone.id);
  const [selectedTimezone, setSelectedTimezone] = useState<number | undefined>(
    undefined
  );
  const [modal, contextHolder] = Modal.useModal();
  const [loading, setLoading] = useState(false);

  const countNumberOfResources = async () => {
    if (!selectedTimezone) return;
    try {
      setLoading(true);
      const reservationNum = await fetchNumberOfReservationsToBeMoved(
        selectedTimezone,
        timeZone.id
      );
      setLoading(false);
      if (reservationNum === 0) {
        message.info('No reservations to move.');
        return;
      }
      modal.confirm({
        title: 'Move reservations',
        content: `Are you sure you want to move ${reservationNum} reservations to ${timeZone.name}?`,
        onOk() {
          moveReservations();
        },
      });
    } catch (error) {}
  };

  const moveReservations = async () => {
    if (!selectedTimezone) return;
    try {
      setLoading(true);
      const reservationNum = await moveReservationsBetweenTimeZones(
        selectedTimezone,
        timeZone.id
      );
      setLoading(false);
      message.success(
        reservationNum
          ? `${reservationNum} reservations moved`
          : `No reservations moved`
      );
    } catch (error) {}
  };

  return (
    <TEDrawerSection label="Move resources to this time zone">
      <div className="time-rule-general-info">
        <TEInput.Select
          label="From timezone"
          tooltip="From timezone"
          value={selectedTimezone}
          onChange={(value) => setSelectedTimezone(value)}
          options={otherTimezones.map((zone) => ({
            label: zone.name,
            value: zone.id,
          }))}
        />
        <TEInput.LabelWrapper
          label="Reservations"
          tooltip="Reservations"
          flow="row"
        >
          <Button
            danger
            size="small"
            disabled={!selectedTimezone}
            onClick={() => countNumberOfResources()}
            loading={loading}
          >
            Move reservations
          </Button>
        </TEInput.LabelWrapper>
        {contextHolder}
      </div>
    </TEDrawerSection>
  );
};

export default MoveResources;
